import * as React from 'react';
import cn from '~modules/cn';
import InfoIcon from '../../../assets/icons/v2design/basics/info.svg';

import './info-message.scss';

export type InfoMessageType = 'default' | 'transparent' | 'error' | 'warn' | 'success' | 'noIcon';

const INFO_MESSAGE_CLASS: Record<InfoMessageType, string | null> = {
    default: null,
    transparent: 'info-message--transparent',
    error: 'info-message--red',
    warn: 'info-message--yellow',
    success: 'info-message--success',
    noIcon: null
};

const INFO_MESSAGE_ICON: Record<InfoMessageType, JSX.Element | null> = {
    default: <InfoIcon />,
    transparent: <InfoIcon />,
    error: <InfoIcon />,
    warn: <InfoIcon />,
    success: <InfoIcon />,
    noIcon: null
};

type InfoMessageProps = {
    message?: string | JSX.Element;
    type: InfoMessageType;
    icon?: JSX.Element;
    children?: React.ReactNode;
    className?: string;
    fullWidth?: boolean;
    centered?: boolean;
};

export const InfoMessage = ({ message, centered, type, icon, children, className, fullWidth }: InfoMessageProps): JSX.Element => {
    const messageIcon = icon || INFO_MESSAGE_ICON[type];

    return (
        <div
            className={cn(
                'info-message',
                {
                    'info-message--full-width': fullWidth,
                    'info-message--centered': centered
                },
                className,
                INFO_MESSAGE_CLASS[type]
            )}
        >
            <div
                className={cn('info-message-title-container', {
                    'info-message-title-container--flex': fullWidth
                })}
            >
                {messageIcon && <span className="info-message-icon-wrapper">{messageIcon}</span>}
                <span>{message}</span>
            </div>
            {children && <div className="info-message-contents">{children}</div>}
        </div>
    );
};
